import type { GatsbyBrowser } from "gatsby";

const scrollToTop = () => {
  const reset = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  };

  reset();
  window.requestAnimationFrame(reset);
};

export const shouldUpdateScroll: GatsbyBrowser["shouldUpdateScroll"] = ({
  routerProps,
}) => {
  const { location } = routerProps;

  if (location.hash) {
    return true;
  }

  scrollToTop();

  return false;
};
